/**
 * Available only in the current session of the browser.
 * Falls back to in-memory storage if sessionStorage is blocked by the browser.
 */
let inMemoryInvitationToken = null;

export default class AuthInvitationToken {
  static get() {
    try {
      return sessionStorage.getItem('invitationToken') || null;
    } catch {
      return inMemoryInvitationToken;
    }
  }

  static set(token) {
    try {
      sessionStorage.setItem('invitationToken', token);
    } catch {
      inMemoryInvitationToken = token;
    }
  }

  static clear() {
    try {
      sessionStorage.removeItem('invitationToken');
    } catch {
      inMemoryInvitationToken = null;
    }
  }
}
